import NewCourse from "@/views/Home/ktpCourse/newCourse.vue";
import JoinCourse from '@/views/Home/ktpCourse/joinCourse.vue';
import FiledCourse from "@/views/Home/ktpCourse/filedCourse.vue";
import MyInfoDetail from "@/views/Home/ktpMy/myInfoDetail.vue";
import MyAllSetting from "@/views/Home/ktpMy/myAllSetting.vue";
import infoModify from "@/views/Home/ktpMy/AllInfoModify.vue";
import CourseIntro from '@/views/Home/ktpCourse/courseIntro.vue'
import SeniorSetting from '@/views/Home/ktpCourse/seniorSetting.vue'
import enrollSetting from '@/views/Home/ktpCourse/enrollSetting.vue'
import createCourseFromDemo from "@/views/Home/ktpCourse/createCourseFromDemo.vue";
import newCourseModule from '@/views/Home/ktpCourse/chooseCourseModule.vue'
import i18n from "@/lang";

export default [
  {
    path: '/newCourse',
    name: i18n.t('Home.新建课程') as string,
    component: NewCourse,
  }, {
    path: '/chooseCourseModule',
    name: i18n.t('Home.选择课程模板') as string,
    component: newCourseModule
  }, {
    path: '/joinCourse',
    name: i18n.t('Home.Handle.加入课程') as string,
    component: JoinCourse,
  },{
    path: '/joinCourses',
    name: i18n.t('Home.Handle.加入课程') as string,
    component: JoinCourse,
  }
  ,{
    path: '/filedCourse',
    name: i18n.t('Home.Handle.归档管理') as string,
    component: FiledCourse,
  },{
    path: '/createCourseFromDemo',
    name: '从示范包创建',
    component: createCourseFromDemo,
  },{
    path: '/courseIntro',
    name: i18n.t('CourseHome.课程介绍') as string,
    component: CourseIntro,
  },{
    path: '/seniorSetting',
    name: i18n.t('Home.报名设置') as string,
    component: enrollSetting,
  },

]
